export const camo = [
  {
    number: 'CBB100_A',
    hasModel: false,
  },
  {
    number: 'CBB100_B',
    hasModel: false,
  },
  {
    number: 'CBB100_C',
    hasModel: false,
  },
  {
    number: 'CBB100_D',
    hasModel: false,
  },
  {
    number: 'CBB100_E',
    hasModel: false,
  },
  {
    number: 'CBB101',
    hasModel: false,
  },
  {
    number: 'CBB102',
    hasModel: false,
  },
  {
    number: 'CBB103',
    hasModel: false,
  },
  {
    number: 'CBB104',
    hasModel: false,
  },
  {
    number: 'CBB105',
    hasModel: false,
  },
  {
    number: 'CBB106',
    hasModel: false,
  },
  {
    number: 'CBB107',
    hasModel: false,
  },
  {
    number: 'CBB108',
    hasModel: false,
  },
  {
    number: 'CBB109',
    hasModel: false,
  },
];
